import React, { createContext, useState, useContext, useRef, useEffect } from 'react';
import { bookingsStore, breadCrumbStore, configStore, loginStore, newDashboardState } from '../state/CommonState';

const PricingContext = createContext();

export const usePricing = () => useContext(PricingContext);

export const PricingContextProvider = ({ children }) => {
 
    const [rec,setRec] = useState(null);
    const [isInidaDoor,setIndiaDoor] = useState(false);
    const [showShipperPDA,setShowShipperPDA] = useState({showShipper:false,include:false,currentStatus:false});
    const [disableInclusion,setDisable] = useState(false);
    const [changeCount,setChangeCount] = useState(0);
    const [total,setTotal] = useState(0);
    const [isSpot,setIsSpot] = useState(false);
    const [isContract,setContract] = useState(false)
    const changeCharges = (included,chargeDescription)=>{
        if(included){
            included = "Yes"
        }else{
            included = "No"
        }
        
        let elem = rec.chargesList.find(e1 => chargeDescription == e1.chargeDescription)
        if (elem && elem.isIncluded != included) {
            elem.isIncluded = included
            let erate = configStore.getExchangeRateinr(elem)
            if (!erate || erate === 0) erate = 1.0
            let amt = elem.total * erate
            if (included != 'Yes') amt *= -1    
            rec.quoteValue += amt
            let usdRate = configStore.getExchangeRate('USD')
            rec.quoteValueUSD = rec.quoteValue / usdRate
            setChangeCount((prev)=>++prev);
            // setRec({...rec})
            // bookingsStore.current.contract.quoteValue = rec.quoteValue
            // bookingsStore.current.contract.quoteValueUSD = rec.quoteValueUSD
    }
}


useEffect(()=>{
  if(rec){
   if(rec.shipmentScope.includes("Door") && (rec.origin.includes('[IN') || rec.destination.includes('[IN'))){
    setIndiaDoor(true);
   }
   if(rec.mode==="CONTRACT"){
    setContract(true);
   }
   if(rec.mode==="CONTRACT"|| rec.mode==="QUOTE"){
    setDisable(true)
   }
  //  console.log(" the eweebhk ehb ",loginStore.isClient() && breadCrumbStore.breadCrumbs[breadCrumbStore.length-1]==="Create Booking")
  console.log(" the rec is ",bookingsStore.current.contractNum)
   if(bookingsStore.current.contractNum==="SPOT" || rec.quotationNum==="SPOT" || (loginStore.isClient() && (breadCrumbStore.breadCrumbs[breadCrumbStore.breadCrumbs.length-1]==="Create Booking" || breadCrumbStore.breadCrumbs[breadCrumbStore.breadCrumbs.length-1]==="Booking Summary" && breadCrumbStore.breadCrumbs.length<=2) )){
     setIsSpot(true)
   }
  }
},[rec])
    return (
      <PricingContext.Provider value={{changeCharges,rec,setRec,disableInclusion,setDisable,showShipperPDA,setShowShipperPDA,isInidaDoor,changeCount,total,setTotal,isContract,isSpot}}>
        {children}
      </PricingContext.Provider>
    );
  };
  